import React from "react";
import { FaPlusCircle } from "react-icons/fa";

function PlusIcon({ size = 20 }) {
  return <FaPlusCircle size={size} style={{ color: "#363a3d", marginRight: "10px" }} />;
}

export default PlusIcon;
